import axios from 'axios';


const apiUrl = process.env.REACT_APP_BACKEND_URL

const axiosInstance = axios.create({
    baseURL: apiUrl,
    withCredentials: true,
});

axiosInstance.interceptors.request.use(function (config) {
    return config;
}, function (error) {
    return Promise.reject(error);
});

axiosInstance.interceptors.request.use(
    function (config) {
        if (config.data instanceof FormData) {
            config.headers['Content-Type'] = 'multipart/form-data';
        }
        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);

export default axiosInstance;
